<template>
  <div>
    <div style="display: flex; gap: 8px; margin-bottom: 12px;">
      <el-input v-model="query.name" placeholder="Banner 名称" style="width: 200px" @keyup.enter="reload" />
      <el-button type="primary" :loading="loading" @click="reload">查询</el-button>
      <el-button :loading="loading" @click="openDialog()">新建 Banner</el-button>
    </div>

    <el-table v-loading="loading" :data="rows">
      <el-table-column prop="name" label="名称（英文）" min-width="160" />
      <el-table-column label="尺寸（宽×高）" width="140">
        <template #default="scope">{{ scope.row.width }} × {{ scope.row.height }}</template>
      </el-table-column>
      <el-table-column label="游戏数量" width="100">
        <template #default="scope">{{ (scope.row.gameIds || []).length }}</template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" width="200" />
      <el-table-column label="操作" width="280" fixed="right">
        <template #default="scope">
          <el-button size="small" @click="openGamesDialog(scope.row)">管理游戏</el-button>
          <el-button size="small" @click="openDialog(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-size="limit"
        :current-page="page"
        @current-change="pageChange"
      />
    </div>

    <el-dialog v-model="dialogVisible" title="Banner 编辑" width="520px">
      <el-form label-width="100px">
        <el-form-item label="名称（英文）">
          <el-input v-model="form.name" placeholder="如 home_top_banner" />
        </el-form-item>
        <el-form-item label="宽度（px）">
          <el-input-number v-model="form.width" :min="1" :step="1" style="width: 100%" />
        </el-form-item>
        <el-form-item label="高度（px）">
          <el-input-number v-model="form.height" :min="1" :step="1" style="width: 100%" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="gamesDialogVisible" title="管理 Banner 推荐游戏" width="90%">
      <div style="display:flex; gap:8px; margin-bottom: 10px;">
        <el-select v-model="gameSearchQuery.category" clearable filterable placeholder="分类" style="width: 180px;">
          <el-option v-for="c in categoryOptions" :key="c.id" :label="c.name" :value="c.id" />
        </el-select>
        <el-select v-model="gameSearchQuery.isHot" placeholder="是否热门" clearable style="width: 120px;">
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
        <el-input v-model="gameSearchQuery.title" placeholder="按游戏名称搜索" style="width: 220px" @keyup.enter="reloadBannerGames" />
        <el-button type="primary" :loading="gameSearchLoading" @click="reloadBannerGames">查询</el-button>
        <div style="line-height: 32px; color: #606266;">已添加 {{ gamesForm.gameIds.length }} 个</div>
      </div>

      <el-table v-loading="gameSearchLoading" :data="gameSearchRows" max-height="420">
        <el-table-column label="游戏名称" min-width="220">
          <template #default="scope">
            {{ scope.row.title || scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="头像icon" width="110">
          <template #default="scope">
            <el-image
              v-if="scope.row.iconUrl || scope.row.icon"
              :src="scope.row.iconUrl || scope.row.icon"
              style="width: 32px; height: 32px; border-radius: 4px;"
              fit="cover"
            />
            <span v-else style="color:#909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="gameMd5" label="MD5" min-width="220" />
        <el-table-column label="添加到 Banner" width="140" fixed="right">
          <template #default="scope">
            <el-button
              size="small"
              type="primary"
              :loading="savingGames"
              :disabled="isGameAdded(scope.row.gameId)"
              @click="addGameFromRow(scope.row)"
            >
              {{ isGameAdded(scope.row.gameId) ? '已添加' : '添加' }}
            </el-button>
            <el-button
              v-if="isGameAdded(scope.row.gameId)"
              size="small"
              type="danger"
              text
              :loading="savingGames"
              @click="removeGame(scope.row.gameId)"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
        <el-pagination
          layout="prev, pager, next"
          :total="gameSearchTotal"
          :page-size="gameSearchLimit"
          :current-page="gameSearchPage"
          @current-change="bannerGamesPageChange"
        />
      </div>

      <div style="margin-top: 14px;">
        <div style="font-size: 13px; color: #606266; margin-bottom: 8px;">
          已添加游戏（{{ addedGamesMeta.length }}）
        </div>
        <div v-loading="addedGamesLoading" class="added-games-wrap">
          <div v-for="g in addedGamesMeta" :key="g.gameId" class="added-game-item">
            <el-image
              v-if="g.iconUrl || g.icon"
              :src="g.iconUrl || g.icon"
              class="added-game-icon"
              fit="cover"
            />
            <div v-else class="added-game-icon placeholder">-</div>
            <div class="added-game-name">{{ g.title || g.name || g.gameId }}</div>
            <el-button size="small" type="danger" text :loading="savingGames" @click="removeGame(g.gameId!)">移除</el-button>
          </div>
          <div v-if="!addedGamesLoading && addedGamesMeta.length === 0" style="color:#909399;">暂无已添加游戏</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { BannerApi, BannerRow } from '../../api/bannerApi';
import { CategoryOption, Game, GameApi } from '../../api/gameApi';

const NAME_PATTERN = /^[a-zA-Z][a-zA-Z0-9_-]*$/;

export default defineComponent({
  name: 'Banner',
  data() {
    return {
      loading: false,
      saving: false,
      savingGames: false,
      rows: [] as BannerRow[],
      total: 0,
      page: 1,
      limit: 20,
      query: {
        name: '',
      },
      dialogVisible: false,
      form: {
        id: '',
        name: '',
        width: 320,
        height: 100,
      },
      gamesDialogVisible: false,
      gamesForm: {
        id: '',
        gameIds: [] as string[],
      },
      categoryOptions: [] as CategoryOption[],
      gameSearchQuery: {
        category: '',
        title: '',
        isHot: null as boolean | null,
      },
      gameSearchRows: [] as Game[],
      gameSearchLoading: false,
      gameSearchTotal: 0,
      gameSearchPage: 1,
      gameSearchLimit: 20,
      addedGamesLoading: false,
      addedGamesMeta: [] as Game[],
    };
  },
  methods: {
    async init(): Promise<void> {
      this.loading = true;
      try {
        const res = await BannerApi.list((this.page - 1) * this.limit, this.limit, this.query);
        this.rows = res.list;
        this.total = res.total;
      } finally {
        this.loading = false;
      }
    },
    reload(): void {
      this.page = 1;
      this.init();
    },
    pageChange(page: number): void {
      this.page = page;
      this.init();
    },
    openDialog(row?: BannerRow): void {
      this.dialogVisible = true;
      if (!row) {
        this.form = { id: '', name: '', width: 320, height: 100 };
        return;
      }
      this.form = {
        id: row.id,
        name: row.name,
        width: row.width,
        height: row.height,
      };
    },
    async save(): Promise<void> {
      if (!this.form.name || !this.form.width || !this.form.height) {
        ElMessage.error('请填写名称和尺寸');
        return;
      }
      if (!NAME_PATTERN.test(this.form.name)) {
        ElMessage.error('名称须为英文标识（字母开头，可含数字、下划线、连字符）');
        return;
      }
      this.saving = true;
      try {
        if (this.form.id) {
          await BannerApi.update(this.form.id, {
            name: this.form.name,
            width: this.form.width,
            height: this.form.height,
          });
        } else {
          await BannerApi.create({
            name: this.form.name,
            width: this.form.width,
            height: this.form.height,
          });
        }
        ElMessage.success('保存成功');
        this.dialogVisible = false;
        await this.init();
      } finally {
        this.saving = false;
      }
    },
    openGamesDialog(row: BannerRow): void {
      this.gamesDialogVisible = true;
      this.gamesForm = {
        id: row.id,
        gameIds: [...(row.gameIds || [])],
      };
      this.gameSearchPage = 1;
      this.searchBannerGames();
      this.refreshAddedGamesMeta();
    },
    async refreshAddedGamesMeta(): Promise<void> {
      const ids = [...new Set(this.gamesForm.gameIds.filter(Boolean))];
      this.addedGamesMeta = [];
      if (!ids.length) return;
      this.addedGamesLoading = true;
      try {
        const rows = await Promise.all(
          ids.map(async (gid) => {
            const res = await GameApi.getGames({ gameId: gid, skip: 0, limit: 1 } as any);
            return (res.gameList && res.gameList[0]) ? (res.gameList[0] as Game) : ({ gameId: gid } as Game);
          }),
        );
        this.addedGamesMeta = rows;
      } finally {
        this.addedGamesLoading = false;
      }
    },
    async loadCategoryOptions(): Promise<void> {
      try {
        this.categoryOptions = await GameApi.getCategories();
      } catch (_e) {}
    },
    async searchBannerGames(): Promise<void> {
      this.gameSearchLoading = true;
      try {
        const res = await GameApi.getGames({
          category: this.gameSearchQuery.category || null,
          title: this.gameSearchQuery.title || null,
          isHot: this.gameSearchQuery.isHot,
          status: 'online',
          skip: (this.gameSearchPage - 1) * this.gameSearchLimit,
          limit: this.gameSearchLimit,
        });
        this.gameSearchRows = (res.gameList || []).filter((g: any) => !!g.gameId);
        this.gameSearchTotal = res.total || 0;
      } finally {
        this.gameSearchLoading = false;
      }
    },
    reloadBannerGames(): void {
      this.gameSearchPage = 1;
      this.searchBannerGames();
    },
    bannerGamesPageChange(page: number): void {
      this.gameSearchPage = page;
      this.searchBannerGames();
    },
    isGameAdded(gameId?: string): boolean {
      if (!gameId) return false;
      return this.gamesForm.gameIds.includes(gameId);
    },
    async addGameFromRow(row: Game): Promise<void> {
      const gameId = (row as any).gameId;
      if (!gameId) return;
      this.savingGames = true;
      try {
        const updated = await BannerApi.addGame(this.gamesForm.id, gameId);
        this.gamesForm.gameIds = updated.gameIds || [];
        await this.searchBannerGames();
        await this.refreshAddedGamesMeta();
        await this.init();
      } finally {
        this.savingGames = false;
      }
    },
    async removeGame(gameId: string): Promise<void> {
      this.savingGames = true;
      try {
        const updated = await BannerApi.removeGame(this.gamesForm.id, gameId);
        this.gamesForm.gameIds = updated.gameIds || [];
        await this.searchBannerGames();
        await this.refreshAddedGamesMeta();
        await this.init();
      } finally {
        this.savingGames = false;
      }
    },
    remove(row: BannerRow): void {
      ElMessageBox.confirm(`确认删除 Banner「${row.name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await BannerApi.remove(row.id);
        ElMessage.success('删除成功');
        await this.init();
      }).catch(() => {});
    },
  },
  mounted() {
    this.loadCategoryOptions();
    this.init();
  },
});
</script>

<style scoped>
.added-games-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px;
  min-height: 72px;
}

.added-game-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
}

.added-game-icon {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.added-game-icon.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.added-game-name {
  font-size: 12px;
  color: #303133;
  line-height: 1.4;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}
</style>
